module.exports = __webpack_public_path__ + "static/media/MC.fba8cd0d.svg";